// import React, { useState } from 'react';
// import './FormSection.css';

// const FormSection = () => {
//   const [formData, setFormData] = useState({
//     dateStart: '',
//     dateEnd: '',
//     location: '',
//     numberOfPeople: '',
//     name: '',
//     email: '',
//     phone: ''
//   });

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
    
//     // Google Form submission URL - replace with your actual Google Form URL
//     const googleFormUrl = "https://docs.google.com/forms/d/e/YOUR_FORM_ID/formResponse";
    
//     // Create form data for Google Forms
//     const formDataToSubmit = new FormData();
//     formDataToSubmit.append('entry.1234567890', formData.name); // Replace with actual entry IDs
//     formDataToSubmit.append('entry.1234567891', formData.email);
//     formDataToSubmit.append('entry.1234567892', formData.phone);
//     formDataToSubmit.append('entry.1234567893', formData.dateStart);
//     formDataToSubmit.append('entry.1234567894', formData.dateEnd);
//     formDataToSubmit.append('entry.1234567895', formData.location);
//     formDataToSubmit.append('entry.1234567896', formData.numberOfPeople);
    
//     // Submit to Google Form
//     fetch(googleFormUrl, {
//       method: 'POST',
//       body: formDataToSubmit,
//       mode: 'no-cors'
//     }).then(() => {
//       alert('Thank you for your registration! We will contact you soon.');
//       setFormData({
//         dateStart: '',
//         dateEnd: '',
//         location: '',
//         numberOfPeople: '',
//         name: '',
//         email: '',
//         phone: ''
//       });
//     }).catch(error => {
//       console.error('Error submitting form:', error);
//       alert('There was an error submitting the form. Please try again.');
//     });
//   };

//   const todayStr = new Date().toISOString().split('T')[0];
//   const endMin = formData.dateStart ? formData.dateStart : todayStr;

//   return (
//     <section className="section form-section" id="form">
//       <div className="container">
//         <div className="section-header">
//           <h2>Book now for Your Dream Trip</h2>
//           <p>Fill out the form below to start planning your perfect adventure with Ghoomo India</p>
//         </div>
        
//         <div className="form-container">
//           <div className="form-card">
//             <form onSubmit={handleSubmit} className="registration-form">
//               <div className="form-grid">
//                 <div className="form-group">
//                   <label htmlFor="name">Full Name *</label>
//                   <input
//                     type="text"
//                     id="name"
//                     name="name"
//                     value={formData.name}
//                     onChange={handleInputChange}
//                     required
//                     placeholder="Enter your full name"
//                   />
//                 </div>
                
//                 <div className="form-group">
//                   <label htmlFor="email">Email Address *</label>
//                   <input
//                     type="email"
//                     id="email"
//                     name="email"
//                     value={formData.email}
//                     onChange={handleInputChange}
//                     required
//                     placeholder="Enter your email address"
//                   />
//                 </div>
                
//                 <div className="form-group full-width">
//                   <label htmlFor="phone">Phone Number *</label>
//                   <input
//                     type="tel"
//                     id="phone"
//                     name="phone"
//                     value={formData.phone}
//                     onChange={handleInputChange}
//                     required
//                     placeholder="Enter your phone number"
//                   />
//                 </div>
                
//                 <div className="form-group">
//                   <label htmlFor="dateStart">Start Date *</label>
//                   <input
//                     type="date"
//                     id="dateStart"
//                     name="dateStart"
//                     value={formData.dateStart}
//                     onChange={handleInputChange}
//                     required
//                     min={todayStr}
//                   />
//                 </div>
                
//                 <div className="form-group">
//                   <label htmlFor="dateEnd">End Date *</label>
//                   <input
//                     type="date"
//                     id="dateEnd"
//                     name="dateEnd"
//                     value={formData.dateEnd}
//                     onChange={handleInputChange}
//                     required
//                     min={endMin}
//                   />
//                 </div>
                
//                 <div className="form-group">
//                   <label htmlFor="location">Preferred Location *</label>
//                   <select
//                     id="location"
//                     name="location"
//                     value={formData.location}
//                     onChange={handleInputChange}
//                     required
//                   >
//                     <option value="">Select a location</option>
//                     <option value="Kerala">Kerala</option>
//                     <option value="Goa">Goa</option>
//                     <option value="Rajasthan">Rajasthan</option>
//                     <option value="Himachal Pradesh">Himachal Pradesh</option>
//                     <option value="Uttarakhand">Uttarakhand</option>
//                     <option value="Kashmir">Kashmir</option>
//                     <option value="Ladakh">Ladakh</option>
//                     <option value="Sikkim">Sikkim</option>
//                     <option value="North East">North East</option>
//                     <option value="Custom Package">Custom Package</option>
//                   </select>
//                 </div>
                
//                 <div className="form-group">
//                   <label htmlFor="numberOfPeople">Number of People *</label>
//                   <select
//                     id="numberOfPeople"
//                     name="numberOfPeople"
//                     value={formData.numberOfPeople}
//                     onChange={handleInputChange}
//                     required
//                   >
//                     <option value="">Select number of people</option>
//                     <option value="1">1 Person</option>
//                     <option value="2">2 People</option>
//                     <option value="3">3 People</option>
//                     <option value="4">4 People</option>
//                     <option value="5">5 People</option>
//                     <option value="6+">6+ People</option>
//                   </select>
//                 </div>
//               </div>
              
//               <div className="form-actions">
//                 <button type="submit" className="btn btn-primary">
//                   Submit 
//                 </button>
//               </div>
//             </form>
//           </div>
          
//           <div className="form-info">
//             <h3>Why Register with Us?</h3>
//             <div className="info-features">
//               <div className="info-feature">
//                 <span className="feature-icon">✓</span>
//                 <div>
//                   <h4>Personalized Planning</h4>
//                   <p>Get customized travel itineraries based on your preferences</p>
//                 </div>
//               </div>
//               <div className="info-feature">
//                 <span className="feature-icon">✓</span>
//                 <div>
//                   <h4>Expert Guidance</h4>
//                   <p>Professional travel consultants to help you plan the perfect trip</p>
//                 </div>
//               </div>
//               <div className="info-feature">
//                 <span className="feature-icon">✓</span>
//                 <div>
//                   <h4>Best Deals</h4>
//                   <p>Access to exclusive discounts and special offers</p>
//                 </div>
//               </div>
//               <div className="info-feature">
//                 <span className="feature-icon">✓</span>
//                 <div>
//                   <h4>24/7 Support</h4>
//                   <p>Round-the-clock assistance during your journey</p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default FormSection;


import React, { useState } from 'react';
import './FormSection.css';

const FormSection = () => {
  const [formData, setFormData] = useState({
    dateStart: '',
    dateEnd: '',
    location: '',
    numberOfPeople: '',
    name: '',
    email: '',
    phone: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const googleFormUrl = "https://docs.google.com/forms/d/e/1FAIpQLSdWNDyo8ZDKpL0FZK_7Otr5DaAKQPqYCMQGiQUdyW5SmQYvvQ/formResponse";

    const startDate = new Date(formData.dateStart);
    const endDate = new Date(formData.dateEnd);

    const formDataToSubmit = new URLSearchParams();
    formDataToSubmit.append('entry.716209756', formData.name);
    formDataToSubmit.append('entry.195583856', formData.email);
    formDataToSubmit.append('entry.1090269713', formData.phone);
    formDataToSubmit.append('entry.1966899686', formData.location);
    formDataToSubmit.append('entry.620694833', formData.numberOfPeople);

    // Start date
    formDataToSubmit.append('entry.159043036_year', startDate.getFullYear());
    formDataToSubmit.append('entry.159043036_month', startDate.getMonth() + 1);
    formDataToSubmit.append('entry.159043036_day', startDate.getDate());

    // End date
    formDataToSubmit.append('entry.1798889839_year', endDate.getFullYear());
    formDataToSubmit.append('entry.1798889839_month', endDate.getMonth() + 1);
    formDataToSubmit.append('entry.1798889839_day', endDate.getDate());

    // Submit using a hidden iframe to bypass CORS
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    document.body.appendChild(iframe);

    const form = document.createElement('form');
    form.action = googleFormUrl;
    form.method = 'POST';
    form.target = iframe.name;

    for (const [key, value] of formDataToSubmit.entries()) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = value;
      form.appendChild(input);
    }

    document.body.appendChild(form);
    form.submit();

    alert('✅ Thank you! Your booking information has been submitted.');

    setFormData({
      dateStart: '',
      dateEnd: '',
      location: '',
      numberOfPeople: '',
      name: '',
      email: '',
      phone: ''
    });

    // Clean up
    document.body.removeChild(form);
    document.body.removeChild(iframe);
  };

  const todayStr = new Date().toISOString().split('T')[0];
  const endMin = formData.dateStart ? formData.dateStart : todayStr;

  return (
    <section className="section form-section" id="form">
      <div className="container">
        <div className="section-header">
          <h2>Book now for Your Dream Trip</h2>
          <p>Fill out the form below to start planning your perfect adventure with Ghoomo India</p>
        </div>

        <div className="form-container">
          <div className="form-card">
            <form onSubmit={handleSubmit} className="registration-form">
              <div className="form-grid">
                <div className="form-group">
                  <label htmlFor="name">Full Name *</label>
                  <input type="text" id="name" name="name" value={formData.name} onChange={handleInputChange} required placeholder="Enter your full name"/>
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email Address *</label>
                  <input type="email" id="email" name="email" value={formData.email} onChange={handleInputChange} required placeholder="Enter your email address"/>
                </div>

                <div className="form-group full-width">
                  <label htmlFor="phone">Phone Number *</label>
                  <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleInputChange} required placeholder="Enter your phone number"/>
                </div>

                <div className="form-group">
                  <label htmlFor="dateStart">Start Date *</label>
                  <input type="date" id="dateStart" name="dateStart" value={formData.dateStart} onChange={handleInputChange} required min={todayStr}/>
                </div>

                <div className="form-group">
                  <label htmlFor="dateEnd">End Date *</label>
                  <input type="date" id="dateEnd" name="dateEnd" value={formData.dateEnd} onChange={handleInputChange} required min={endMin}/>
                </div>

                <div className="form-group">
                  <label htmlFor="location">Preferred Location *</label>
                  <input type="text" id="name" name="name" value={formData.name} onChange={handleInputChange} required placeholder="Enter the destination name"/>
                </div>

                <div className="form-group">
                  <label htmlFor="numberOfPeople">Number of People *</label>
                  <select id="numberOfPeople" name="numberOfPeople" value={formData.numberOfPeople} onChange={handleInputChange} required>
                    <option value="">Select number of people</option>
                    <option value="1">1 Person</option>
                    <option value="2">2 People</option>
                    <option value="3">3 People</option>
                    <option value="4">4 People</option>
                    <option value="5">5 People</option>
                    <option value="6+">6+ People</option>
                  </select>
                </div>
              </div>

              <div className="form-actions">
                <button type="submit" className="btn btn-primary">Submit</button>
              </div>
            </form>
          </div>

          <div className="form-info">
            <h3>Why Register with Us?</h3>
            <div className="info-features">
              <div className="info-feature">
                <span className="feature-icon">✓</span>
                <div>
                  <h4>Personalized Planning</h4>
                  <p>Get customized travel itineraries based on your preferences</p>
                </div>
              </div>
              <div className="info-feature">
                <span className="feature-icon">✓</span>
                <div>
                  <h4>Expert Guidance</h4>
                  <p>Professional travel consultants to help you plan the perfect trip</p>
                </div>
              </div>
              <div className="info-feature">
                <span className="feature-icon">✓</span>
                <div>
                  <h4>Best Deals</h4>
                  <p>Access to exclusive discounts and special offers</p>
                </div>
              </div>
              <div className="info-feature">
                <span className="feature-icon">✓</span>
                <div>
                  <h4>24/7 Support</h4>
                  <p>Round-the-clock assistance during your journey</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};


export default FormSection;
